import { FieldValidation } from '@rjsf/utils';
import { AzureSubscription } from './useAzureSubscriptions';

export const validateAzureSubscription = (
  subscription: AzureSubscription | undefined,
  validation: FieldValidation,
) => {
  if (subscription === undefined) return;
  if (!subscription?.subscriptionId || !subscription?.displayName) {
    validation.addError('Please select a valid Azure subscription');
  }
};
